import styled from 'styled-components'

export const ContentContainer = styled.div`
  background-color: #46464F;
  border-radius: 8px;
  text-align: center;
  color: #FCF8FD;
  padding: 0.5rem;
`
